'use strict';

angular.module('mean.options').factory('TradeOption', ['$filter',
  function($filter) {
    var number = null;
    var description = null;
    var has_multiple = null;
    var name = null;
    var subtasks = [];
    var plans = [];
    var trades = [];
    var revisions = [];

    //constructor
    function TradeOption(obj) {
        this.number = obj.number;
        this.description = obj.description;
        this.has_multiple = obj.has_multiple;
        this.name = obj.name;
        this.subtasks = obj.subtasks;
        this.plans = obj.plans;
        this.trades = obj.trades;
        this.revisions = obj.revisions;
    }

    //pass in -1 for all revisions
    TradeOption.prototype.getSubtasks = function(revision) {
        var list = [];

        if(revision === -1) {
            list = this.subtasks;
        } else {
            list = $filter('filter')(this.subtasks, {'revision': revision}, true);
        }

        return list;
    };

    TradeOption.prototype.getSubtasksForPlan = function(revision, plan) {
        var list = this.getSubtasks(revision);
        return $filter('filter')(list, {'plan': plan}, true);
    };

    TradeOption.prototype.addToRevisionRevisions = function(number) {
        this.revisions.push({
            'number': number
        });
    };

    // TradeOption.number = angular.copy(number);

    // TradeOption.build = function(data) {
    //     console.log('figure this one out');
    // }

    return TradeOption;
  }
]);


// WEBPACK FOOTER //
// ./packages/custom/options/public/services/trade-option.js